export function getColor (status) {
  switch (status) {
    case 'invoiced':
      return '#388E3C'
    case 'ready-for-handling':
      return '#FFA726'
    case 'handling':
      return '#FB8C00'
    case 'canceled':
      return '#D50000'
    case 'payment-approved':
      return '#1E88E5'
    case 'request-cancel':
      return '#D32F2F'
    case 1:
      return '#9AC5DB'
    case 2:
      return '#37474F'
    case 3:
      return '#039BE5'
    case 4:
      return '#1E88E5'
    case 5:
      return '#FFA726'
    case 6:
      return '#FB8C00'
    case 7:
      return '#388E3C'
    case 8:
      return '#D32F2F'
    case 9:
      return '#D50000'
    default:
      return '#263238'
  }
}

export function getStatusSeller (status) {
  switch (status) {
    case 1:
      return 'Não Confirmado'
    case 2:
      return 'Ag. Pagamento'
    case 3:
      return 'Em Expedição'
    case 4:
      return 'Aguardando NFE'
    case 5:
      return 'Aguardando Tracking'
    case 6:
      return 'Aguardando Entrega'
    case 7:
      return 'Entregue'
    case 8:
      return 'Em Cancelamento'
    case 9:
      return 'Cancelado'
  }
}

export function addBusinessDays (d, n) {
  n = parseInt(n)
  d = new Date(d)
  const day = d.getDay()
  d.setDate(d.getDate() + n + (day === 6 ? 2 : +!day) + Math.floor((n - 1 + (day % 6 || 1)) / 5) * 2)
  const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
  return d.toLocaleDateString('pt-BR', options)
}

export function back () {
  this.$router.go(-1)
}

export function formatStringData (data) {
  const dia = data.split('/')[0]
  const mes = data.split('/')[1]
  const ano = data.split('/')[2]
  return ano + '-' + ('0' + mes).slice(-2) + '-' + ('0' + dia).slice(-2) + 'T12:00:00-03:00'
}

export function checkDateLess (date, offset) {
  const dateOffset = 24 * 60 * 60 * 1000 * offset
  const varDate = new Date(date) // dd-mm-YYYY
  const today = new Date()
  today.setTime(today.getTime() + dateOffset)
  return today >= varDate
}

export function checkDateGreater (date, offset) {
  const dateOffset = 24 * 60 * 60 * 1000 * offset
  const varDate = new Date(date) // dd-mm-YYYY
  const today = new Date()
  today.setTime(today.getTime() + dateOffset)
  return today <= varDate
}

export default { getColor, getStatusSeller, addBusinessDays, back, formatStringData, checkDateLess, checkDateGreater }
